var map = {
	"./alabama-rural-studio/hero.jpg": 53,
	"./alabama-rural-studio/photo-1.jpg": 149,
	"./alabama-rural-studio/photo-2.jpg": 150,
	"./alabama-rural-studio/photo-3.jpg": 151,
	"./alabama-rural-studio/photo-4.jpg": 152,
	"./alabama-rural-studio/thumb.jpg": 39,
	"./cambridge-student-accommodation/hero.jpg": 54,
	"./cambridge-student-accommodation/photo-1.jpg": 153,
	"./cambridge-student-accommodation/photo-2.jpg": 154,
	"./cambridge-student-accommodation/photo-3.jpg": 155,
	"./cambridge-student-accommodation/thumb.jpg": 40,
	"./contact/thumb.jpg": 41,
	"./crescent-extension/hero.jpg": 55,
	"./crescent-extension/photo-1.jpg": 156,
	"./crescent-extension/photo-2.jpg": 157,
	"./crescent-extension/photo-3.jpg": 158,
	"./crescent-extension/thumb.jpg": 42,
	"./dukes-park-renovation/hero.jpg": 56,
	"./dukes-park-renovation/photo-1.jpg": 159,
	"./dukes-park-renovation/thumb.jpg": 43,
	"./hall-farm-holiday-lets/hero.jpg": 57,
	"./hall-farm-holiday-lets/thumb.jpg": 44,
	"./hall-farm-threshing-barn/hero.jpg": 58,
	"./hall-farm-threshing-barn/photo-1.jpg": 160,
	"./hall-farm-threshing-barn/photo-2.jpg": 161,
	"./hall-farm-threshing-barn/photo-3.jpg": 162,
	"./hall-farm-threshing-barn/thumb.jpg": 45,
	"./long-road-student-centre/hero.jpg": 59,
	"./long-road-student-centre/photo-1.jpg": 163,
	"./long-road-student-centre/thumb.jpg": 46,
	"./new-mills-incubator/hero.jpg": 60,
	"./new-mills-incubator/thumb.jpg": 47,
	"./sussex-street-mixed-use/hero.jpg": 61,
	"./sussex-street-mixed-use/photo-1.jpg": 164,
	"./sussex-street-mixed-use/photo-2.jpg": 165,
	"./sussex-street-mixed-use/photo-3.jpg": 166,
	"./sussex-street-mixed-use/thumb.jpg": 48,
	"./willow-walk-extension/photo-1.jpg": 167,
	"./willow-walk-extension/photo-2.jpg": 168,
	"./willow-walk-extension/photo-3.jpg": 169,
	"./willow-walk-extension/photo-4.jpg": 170,
	"./willow-walk-extension/thumb.jpg": 49,
	"./willow-walk-remodelling/hero.jpg": 62,
	"./willow-walk-remodelling/photo-1.jpg": 171,
	"./willow-walk-remodelling/photo-2.jpg": 172,
	"./willow-walk-remodelling/photo-3.jpg": 173,
	"./willow-walk-remodelling/thumb.jpg": 50
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects ^\.\/.*$
// module id = 63
// module chunks = 0